module.exports = __webpack_public_path__ + "img/artist-kit.f261ee60.png";